import { quickProperty, designToken } from '../component-tokens';
import { tertiaryNeutralElement, tertiaryElementHover, tertiaryElementFocus, tertiaryElementActive, buttonBase, } from './common';
const button = {
    name: 'button',
    attributes: Object.assign(Object.assign(Object.assign({}, buttonBase), tertiaryNeutralElement), { font: designToken('button-text-large'), height: quickProperty('32px'), width: quickProperty('100%') }),
    states: [
        {
            alias: 'tabs-button-hover',
            name: 'hover',
            attributes: Object.assign({}, tertiaryElementHover),
        },
        {
            name: 'focus',
            alias: 'tabs-button-focus',
            attributes: Object.assign({}, tertiaryElementFocus),
        },
        {
            name: 'active',
            alias: 'tabs-button-active',
            attributes: Object.assign({}, tertiaryElementActive),
        },
    ],
};
const item = {
    padding: quickProperty('8px'),
    position: quickProperty('relative'),
    'text-align': quickProperty('center'),
};
const attributes = {
    'border-bottom-width': quickProperty('1px'),
    'border-bottom-style': quickProperty('solid'),
    'border-bottom-color': designToken('field-01'),
    'list-style': quickProperty('none'),
    margin: quickProperty('0'),
    padding: quickProperty('0'),
    display: quickProperty('flex'),
};
const getChildren = (overrides) => [
    {
        name: 'item-selected',
        attributes: Object.assign(Object.assign({}, item), overrides),
        states: [
            {
                name: 'after',
                attributes: {
                    content: quickProperty('""'),
                    'border-radius': quickProperty('4px 4px 0px 0px'),
                    'background-color': designToken('interactive-01'),
                    bottom: quickProperty('-1px'),
                    left: quickProperty('0'),
                    width: quickProperty('100%'),
                    height: quickProperty('4px'),
                    position: quickProperty('absolute'),
                },
            },
        ],
        children: [
            Object.assign(Object.assign({}, button), { name: 'button-active' }),
        ],
    },
    {
        name: 'item',
        attributes: Object.assign(Object.assign({}, item), overrides),
        children: [
            Object.assign(Object.assign({}, button), { attributes: Object.assign(Object.assign({}, button.attributes), { font: designToken('body-medium'), color: designToken('text-02') }) }),
        ],
    },
    {
        name: 'item-disabled',
        attributes: Object.assign(Object.assign({}, item), overrides),
        children: [
            Object.assign(Object.assign({}, button), { name: 'button-disabled', attributes: Object.assign(Object.assign({}, button.attributes), { font: designToken('body-medium'), color: designToken('text-03'), 'pointer-events': quickProperty('none') }), states: [] }),
        ],
    },
];
export const tabsTokens = {
    name: 'tabs',
    tag: 'chameleon-tabs',
    reactImports: 'Tabs, Tab, TabPanel',
    attributes,
    children: getChildren(),
    variants: [
        {
            name: 'full-width',
            attributes,
            children: getChildren({
                flex: quickProperty('1'),
            }),
        },
    ],
};
